import { queryOptions } from "@tanstack/react-query";
import { GeneratedImagesService } from "../service/GeneratedImagesService";

const generatedImagesQueries = {
  all: (spaceId?: string) =>
    queryOptions({
      queryKey: spaceId
        ? ["generated-images", spaceId]
        : ["generated-images"],
      queryFn: () => GeneratedImagesService.getAll({ spaceId }),
    }),
};

export { generatedImagesQueries };
